import React from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import AccordionDetails from '@mui/material/AccordionDetails';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Item from './Item';

const accordionDetailsStyles = {
  backgroundColor: 'surface.white',
  px: 3,
  py: 0,
};

// propOrDashes :: String -> Object -> String
const propOrDashes = R.propOr('--');

const HouseRecipe = ({ compartment }) => {
  const { loadType, recipe, products, additives, destination, volume } = compartment;

  const formattedVolume = R.isEmpty(volume) ? '--' : `${volume} Gallons`;
  const formattedAdditives = additives.map(({ additiveId, name }) => (
    <Box key={additiveId}>{name}</Box>
  ));

  return (
    <AccordionDetails sx={accordionDetailsStyles}>
      <Item label="Load Type" value={propOrDashes('name', loadType)} />
      <Item label="Recipe" value={propOrDashes('name', recipe)} />
      {Object.values(products).map(({ productId, name, supplier, loadingControl }) => (
        <Stack direction="row" justifyContent="space-between" key={productId}>
          <Box width={250}>
            <Item label={`${name} Supplier`} value={propOrDashes('supplierId', supplier)} />
          </Box>
          {R.propEq('hasLoadingControls', true, supplier) && (
            <Box width={87}>
              <Item label="LCN" value={propOrDashes('loadingControlNumber', loadingControl)} />
            </Box>
          )}
        </Stack>
      ))}
      <Item label="Additives" value={additives.length ? formattedAdditives : '--'} />
      <Item label="Destination" value={propOrDashes('name', destination)} />
      <Item label="Volume" value={formattedVolume} />
    </AccordionDetails>
  );
};

HouseRecipe.propTypes = {
  compartment: PropTypes.shape({
    additives: PropTypes.arrayOf(PropTypes.shape({})),
    destination: PropTypes.shape({}),
    loadType: PropTypes.shape({}),
    products: PropTypes.shape({
      supplier: PropTypes.shape({}),
    }),
    recipe: PropTypes.shape({}),
    volume: PropTypes.string,
  }).isRequired,
};

export default HouseRecipe;
